import { io, Socket } from "socket.io-client";
import { v4 } from "uuid";
import { log } from "../logger";

interface SocketHooks {
  eventName: string;
  callback: (state: any) => any;
}

export interface RequestProcessInterface {
  status: string;
  progress: number;
}

export interface SocketConfigOptions {
  userIdentifier: string;
}

const buildOptions = (socketConfigOptions: SocketConfigOptions) => {
  if (socketConfigOptions?.userIdentifier) {
    return {
      query: {
        userIdentifier: socketConfigOptions.userIdentifier,
      },
    };
  }

  return null;
};
class SocketClient {
  private socket: Socket;
  private socketState: string;
  private id: string;
  private room: string;
  constructor(private url: string, private hooks: Array<SocketHooks> = []) {}

  prepare(options?: SocketConfigOptions): Promise<any> {
    return new Promise((resolve, reject) => {
      console.log("connection preparing...");
      if (this.socket) {
        console.warn('Socket already exists. disconnecting socket.');
        // First clear the current socket connection
        try {
          this.socket.disconnect();
          this.socket.close();
        } catch(err) {
          console.error("Could not disconnect and close socket.", err);
        }
      }

      const builtOptionsObject = buildOptions(options);
      console.log("socket connecting to ", this.url, builtOptionsObject);
      this.socket = io(this.url, builtOptionsObject);
      if (builtOptionsObject?.query?.userIdentifier) {
        this.room = builtOptionsObject.query.userIdentifier;
      }
      this.socket.on("connect", () => {
        this.id = this.socket.id;
        this.socketState = "connected";
        resolve(this.socket);
      });

      this.socket.on("disconnect", () => {
        console.log("socket disconnected");
        this.teardown();
      });
      // Setup
      this.setup();
      resolve(this);
    });
  }

  public getRoom() {
    return this.room;
  }

  is(val: string) {
    return this.socketState == val;
  }
  
  public removeAllListeners() {
    if(this.socket) {
      try {
        this.socket.offAny();
      } catch(err) {
        console.error(err);
        return this;
      }
    }
  }

  public on(
    eventName: string,
    callbackFn: (...passedData: any) => any,
    identifier?: string
  ) {
    if (this.socket) {
      console.log("Adding hooks to socket", eventName);
      this.socket.on(eventName, callbackFn);
    } else {
      this.hooks.push({
        eventName,
        callback: callbackFn,
      });
    }
  }

  public clearListeners() {
    this.hooks.forEach((hook) => {
      this.socket.off(hook.eventName, hook.callback);
    });
  }

  private setup() {
    this.hooks.forEach((hook) => {
      this.socket.on(hook.eventName, hook.callback);
    });
  }

  private teardown() {
    this.clearListeners();
  }
}

export default SocketClient;
